import Vue from "vue";
import Vuetify from "vuetify";
import ar from 'vuetify/src/locale/ar'
import en from 'vuetify/src/locale/en'
Vue.use(Vuetify);
export default new Vuetify({
    rtl: localStorage.locale == 'ar' || localStorage.locale == undefined ,
    lang: {
        locales: { ar, en },
        current: localStorage.locale,
    },
});
